module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Edit Product","buttons":{"cancel":"Cancel","save":"Save"},"alerts":{"success":"Product updated successfully!","error":"An error occurred when updating the product!"}},"pt-BR":{"title":"Editar Produto","buttons":{"cancel":"Cancelar","save":"Salvar"},"alerts":{"success":"Produto atualizado com sucesso!","error":"Erro ao atualizar o produto!"}}}')
  delete Component.options._Ctor
}
